import { AboutIcon } from "assets/svg/about";
import { MailIcon } from "assets/svg/mail";
import { MembershipIcon } from "assets/svg/membership";
import { TelephoneIcon } from "assets/svg/telephone";
import { WorkIcon } from "assets/svg/work";
import { inject, observer } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";
import Box from "react-raster";
import { Avatar, Heading, Paper, Spacer, Text } from "src/components";
import { theme } from "src/config";
import { MatchParams } from "src/routes";
import { RoutingStore, UserStore } from "src/stores";
import styled from "styled-components";

const AboutMeContainer = styled.div`
  display: flex;
  align-items: left;
  justify-content: left;
  margin-left: 0.5rem;
`;

const ItemContainer = styled.li<{ hide?: boolean }>`
  display: flex;
  flex-direction: row;
  opacity: ${(props) => (props.hide ? "0" : "1")};
  overflow: hidden;
  transition: 0.3s ease-in-out;
  column-gap: 1.5rem;
  align-items: center;
  padding: ${(props) =>
    props.hide ? "0rem 0.5rem 0rem 1rem" : "0.75rem 0.5rem 0.75rem 1.5rem"};
`;

export interface IProfileProps {
  userStore?:    UserStore;
  routingStore?: RoutingStore;
  params:        MatchParams;
}

export const UserProfile = inject(
  "userStore",
  "routingStore"
)(
  observer((props: IProfileProps): JSX.Element => {
    const { t, i18n } = useTranslation();

    const user = props.userStore.getItemByID(Number(props.params.user_id));

    if (!user) return <></>;

    return (
      <Paper $noShadow style={theme.paper.small}>
        <Box
          display       = "flex"
          gridRowGap    = {theme.layout.gutter}
          alignItems    = "center"
          marginBottom  = "4rem"
          flexDirection = "column"
        >
          <Avatar
            image    = {user.getAvatar}
            size     = "large"
            initials = {user.getInitials}
            onClick  = {() => {}}
          />
          <Heading type="h3">{user.getFullName}</Heading>
        </Box>

        <ItemContainer>
          <TelephoneIcon />
          <Heading type="h2">{user.phone}</Heading>
        </ItemContainer>
        <Spacer />
        <ItemContainer>
          <MailIcon />
          <Heading type="h2">{user.email}</Heading>
        </ItemContainer>
        <Spacer />
        <ItemContainer>
          <WorkIcon />
          <Heading type="h2">{user.company_name}</Heading>
        </ItemContainer>
        <Spacer />
        <Spacer />
        <ItemContainer>
          <MembershipIcon />
          <Heading type="h2">
            {new Date(user.created_at).toLocaleDateString()}
          </Heading>
        </ItemContainer>
        <Spacer />
        <ItemContainer>
          <AboutIcon />
          <AboutMeContainer>
            <Text>{user.description}</Text>
          </AboutMeContainer>
        </ItemContainer>
        <div onBlur={(e) => {}}></div>
      </Paper>
    );
  })
);
